module.exports = __webpack_public_path__ + "media/interview_etiquette/true-af725b32.png";